import { render, staticRenderFns } from "./WidgetExplanationDrawer.vue?vue&type=template&id=53fe9fe7&scoped=true"
import script from "./WidgetExplanationDrawer.vue?vue&type=script&lang=js"
export * from "./WidgetExplanationDrawer.vue?vue&type=script&lang=js"
import style0 from "./WidgetExplanationDrawer.vue?vue&type=style&index=0&id=53fe9fe7&prod&scoped=true&lang=css"
import style1 from "./WidgetExplanationDrawer.vue?vue&type=style&index=1&id=53fe9fe7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe9fe7",
  null
  
)

export default component.exports